// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uYCh4","badges":"styles_badges__jhAQ7"};